import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Card from '@/components/layout/Card.vue';
import { AuthItemAttribute, AuthItemAttributeMapping } from '@/store/models/authItem';
import { AuthItemAttributeMappingType, AuthItemAttributeRuleMapping } from '@/store/enums/authItemEnum';
import MainTitle from '@/components/title/MainTitle.vue';
import store from '@/store';
import { AUTH_ITEM_CHANGE_ATTRIBUTE } from '@/store/actions/authItem';
var AuthItemsAttributeMappingDialog = /*#__PURE__*/function (_Vue) {
  function AuthItemsAttributeMappingDialog() {
    var _this;
    _classCallCheck(this, AuthItemsAttributeMappingDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AuthItemsAttributeMappingDialog, [].concat(args));
    _defineProperty(_this, "isMapAttributeModalActive", void 0);
    _defineProperty(_this, "visible", false);
    _defineProperty(_this, "authItemAttributesOptions", []);
    _defineProperty(_this, "additionalRuleOptions", []);
    _defineProperty(_this, "authItemListOptions", []);
    _defineProperty(_this, "authItem", void 0);
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "UNMAPPED", 'UNMAPPED');
    _defineProperty(_this, "emailAttributeMap", _this.UNMAPPED);
    _defineProperty(_this, "loginAttributeMap", _this.UNMAPPED);
    _defineProperty(_this, "firstNameAttributeMap", _this.UNMAPPED);
    _defineProperty(_this, "lastNameAttributeMap", _this.UNMAPPED);
    _defineProperty(_this, "trainerAttributeMap", _this.UNMAPPED);
    _defineProperty(_this, "aiEditorAttributeMap", _this.UNMAPPED);
    _defineProperty(_this, "approverAttributeMap", _this.UNMAPPED);
    _defineProperty(_this, "adminAttributeMap", _this.UNMAPPED);
    _defineProperty(_this, "groupAttributeMap", _this.UNMAPPED);
    _defineProperty(_this, "authorizationAttributeMap", _this.UNMAPPED);
    _defineProperty(_this, "ruleTrainer", AuthItemAttributeRuleMapping.EXIST);
    _defineProperty(_this, "ruleAIEditor", AuthItemAttributeRuleMapping.EXIST);
    _defineProperty(_this, "ruleApprover", AuthItemAttributeRuleMapping.EXIST);
    _defineProperty(_this, "ruleAdmin", AuthItemAttributeRuleMapping.EXIST);
    _defineProperty(_this, "ruleGroup", AuthItemAttributeRuleMapping.LIST);
    _defineProperty(_this, "ruleValueTrainer", 'true');
    _defineProperty(_this, "ruleValueAIEditor", 'true');
    _defineProperty(_this, "ruleValueApprover", 'true');
    _defineProperty(_this, "ruleValueAdmin", 'true');
    _defineProperty(_this, "ruleValueGroup", ',');
    return _this;
  }
  _inherits(AuthItemsAttributeMappingDialog, _Vue);
  return _createClass(AuthItemsAttributeMappingDialog, [{
    key: "setAdditionalRuleOptions",
    value: function setAdditionalRuleOptions() {
      this.additionalRuleOptions = [{
        'label': this.$t('authentications_management.auth_item.auth_mappings_modal.profiles_block.additional_rule_options.contain_value').toString(),
        'value': AuthItemAttributeRuleMapping.CONTAIN_VALUE
      }, {
        'label': this.$t('authentications_management.auth_item.auth_mappings_modal.profiles_block.additional_rule_options.exact_value').toString(),
        'value': AuthItemAttributeRuleMapping.EXACT_VALUE
      }, {
        'label': this.$t('authentications_management.auth_item.auth_mappings_modal.profiles_block.additional_rule_options.not_contain').toString(),
        'value': AuthItemAttributeRuleMapping.NOT_CONTAIN
      }, {
        'label': this.$t('authentications_management.auth_item.auth_mappings_modal.profiles_block.additional_rule_options.exist').toString(),
        'value': AuthItemAttributeRuleMapping.EXIST
      }];
    }
  }, {
    key: "setAuthItemListOptions",
    value: function setAuthItemListOptions() {
      this.authItemListOptions = [{
        'label': this.$t('authentications_management.auth_item.auth_mappings_modal.groups_affectation_block.list_options.split').toString(),
        'value': AuthItemAttributeRuleMapping.SPLIT
      }, {
        'label': this.$t('authentications_management.auth_item.auth_mappings_modal.groups_affectation_block.list_options.list').toString(),
        'value': AuthItemAttributeRuleMapping.LIST
      }];
    }
  }, {
    key: "authItemAttributeRuleMapping",
    get: function get() {
      return AuthItemAttributeRuleMapping;
    }
  }, {
    key: "valueExplanationToolTip",
    get: function get() {
      return this.$t('authentications_management.auth_item.auth_mappings_modal.mapping_value_tooltip').toString();
    }
  }, {
    key: "recordMapping",
    value: function recordMapping() {
      var _this2 = this;
      var mapAttribute = {};
      var addMapping = function addMapping(name, type, valueMap, ruleType) {
        if (name === _this2.UNMAPPED) {
          return;
        }
        // //we search the email Map
        // //email Mapping
        var attribute = mapAttribute[name];
        if (attribute === undefined) {
          attribute = new AuthItemAttribute();
          attribute.name = name;
          attribute.mapping = new Array();
          attribute.testValue = '';
          mapAttribute[name] = attribute;
        }
        var mapping = new AuthItemAttributeMapping();
        mapping.ruleType = ruleType;
        mapping.valueMap = valueMap;
        mapping.type = type;
        attribute.mapping.push(mapping);
      };
      // map email Attribute
      addMapping(this.emailAttributeMap, AuthItemAttributeMappingType.EMAIL, '', AuthItemAttributeRuleMapping.NO_RULE);
      addMapping(this.loginAttributeMap, AuthItemAttributeMappingType.LOGIN, '', AuthItemAttributeRuleMapping.NO_RULE);
      addMapping(this.firstNameAttributeMap, AuthItemAttributeMappingType.FIRSTNAME, '', AuthItemAttributeRuleMapping.NO_RULE);
      addMapping(this.lastNameAttributeMap, AuthItemAttributeMappingType.LASTNAME, '', AuthItemAttributeRuleMapping.NO_RULE);
      addMapping(this.trainerAttributeMap, AuthItemAttributeMappingType.TRAINER, this.ruleValueTrainer, this.ruleTrainer);
      addMapping(this.aiEditorAttributeMap, AuthItemAttributeMappingType.AI_EDITOR, this.ruleValueAIEditor, this.ruleAIEditor);
      addMapping(this.approverAttributeMap, AuthItemAttributeMappingType.APPROVER, this.ruleValueApprover, this.ruleApprover);
      addMapping(this.adminAttributeMap, AuthItemAttributeMappingType.ADMINISTRATOR, this.ruleValueAdmin, this.ruleAdmin);
      addMapping(this.groupAttributeMap, AuthItemAttributeMappingType.GROUPS, this.ruleValueGroup, this.ruleGroup);
      addMapping(this.authorizationAttributeMap, AuthItemAttributeMappingType.AUTHORIZATION, '', AuthItemAttributeRuleMapping.NO_RULE);
      this.loading = true;
      store.dispatch(AUTH_ITEM_CHANGE_ATTRIBUTE, {
        authItemID: this.authItem.authItemID,
        attributes: Object.values(mapAttribute)
      }).then(function (resp) {
        _this2.loading = false;
        _this2.onDialogClose();
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.setAdditionalRuleOptions();
      this.setAuthItemListOptions();
      this.buildAuthItemsAttributesOptions();
      var attribute = this.attributeFor(AuthItemAttributeMappingType.EMAIL);
      if (attribute) {
        this.emailAttributeMap = attribute.name;
      }
      attribute = this.attributeFor(AuthItemAttributeMappingType.LOGIN);
      if (attribute) {
        this.loginAttributeMap = attribute.name;
      }
      attribute = this.attributeFor(AuthItemAttributeMappingType.FIRSTNAME);
      if (attribute) {
        this.firstNameAttributeMap = attribute.name;
      }
      attribute = this.attributeFor(AuthItemAttributeMappingType.LASTNAME);
      if (attribute) {
        this.lastNameAttributeMap = attribute.name;
      }
      attribute = this.attributeFor(AuthItemAttributeMappingType.TRAINER);
      if (attribute) {
        this.trainerAttributeMap = attribute.name;
        var mapping = this.mappedForAttribute(attribute, AuthItemAttributeMappingType.TRAINER);
        this.ruleTrainer = mapping.ruleType;
        this.ruleValueTrainer = mapping.valueMap;
      }
      attribute = this.attributeFor(AuthItemAttributeMappingType.AI_EDITOR);
      if (attribute) {
        this.aiEditorAttributeMap = attribute.name;
        var _mapping = this.mappedForAttribute(attribute, AuthItemAttributeMappingType.AI_EDITOR);
        this.ruleAIEditor = _mapping.ruleType;
        this.ruleValueAIEditor = _mapping.valueMap;
      }
      attribute = this.attributeFor(AuthItemAttributeMappingType.APPROVER);
      if (attribute) {
        this.approverAttributeMap = attribute.name;
        var _mapping2 = this.mappedForAttribute(attribute, AuthItemAttributeMappingType.APPROVER);
        this.ruleApprover = _mapping2.ruleType;
        this.ruleValueApprover = _mapping2.valueMap;
      }
      attribute = this.attributeFor(AuthItemAttributeMappingType.ADMINISTRATOR);
      if (attribute) {
        this.adminAttributeMap = attribute.name;
        var _mapping3 = this.mappedForAttribute(attribute, AuthItemAttributeMappingType.ADMINISTRATOR);
        this.ruleAdmin = _mapping3.ruleType;
        this.ruleValueAdmin = _mapping3.valueMap;
      }
      attribute = this.attributeFor(AuthItemAttributeMappingType.GROUPS);
      if (attribute) {
        this.groupAttributeMap = attribute.name;
        var _mapping4 = this.mappedForAttribute(attribute, AuthItemAttributeMappingType.GROUPS);
        this.ruleGroup = _mapping4.ruleType;
        this.ruleValueGroup = _mapping4.valueMap;
      }
      attribute = this.attributeFor(AuthItemAttributeMappingType.AUTHORIZATION);
      if (attribute) {
        this.authorizationAttributeMap = attribute.name;
      }
    }
  }, {
    key: "buildAuthItemsAttributesOptions",
    value: function buildAuthItemsAttributesOptions() {
      var _this$authItemAttribu, _this$authItem$authIt;
      this.authItemAttributesOptions.push({
        value: this.UNMAPPED,
        label: this.$t('authentications_management.auth_item.auth_mappings_modal.unmapped_keyword').toString()
      });
      (_this$authItemAttribu = this.authItemAttributesOptions).push.apply(_this$authItemAttribu, _toConsumableArray((_this$authItem$authIt = this.authItem.authItemAttributes) === null || _this$authItem$authIt === void 0 ? void 0 : _this$authItem$authIt.map(function (attr) {
        return {
          value: attr.name,
          label: attr.name
        };
      })));
    }
  }, {
    key: "getLastValueForName",
    value: function getLastValueForName(name) {
      var attribute = this.attributeForName(name);
      if (attribute) {
        return attribute.testValue;
      } else {
        return '';
      }
    }
  }, {
    key: "attributeFor",
    value: function attributeFor(authItemAttributeMappingType) {
      var _iterator = _createForOfIteratorHelper(this.authItem.authItemAttributes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attribute = _step.value;
          var _iterator2 = _createForOfIteratorHelper(attribute.mapping),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var attributeMapping = _step2.value;
              if (attributeMapping.type === authItemAttributeMappingType) {
                return attribute;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return undefined;
    }
  }, {
    key: "mappedForAttribute",
    value: function mappedForAttribute(attribute, authItemAttributeMappingType) {
      var _iterator3 = _createForOfIteratorHelper(attribute.mapping),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var mapping = _step3.value;
          if (mapping.type === authItemAttributeMappingType) {
            return mapping;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return undefined;
    }
  }, {
    key: "attributeForName",
    value: function attributeForName(name) {
      var _iterator4 = _createForOfIteratorHelper(this.authItem.authItemAttributes),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var attribute = _step4.value;
          if (attribute.name === name) {
            return attribute;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return undefined;
    }
  }, {
    key: "onDialogClose",
    value: function onDialogClose() {
      this.visible = false;
      this.errorMsg = '';
      this.$emit("dialogClose");
    }
  }]);
}(Vue);
__decorate([Prop({
  default: false
})], AuthItemsAttributeMappingDialog.prototype, "isMapAttributeModalActive", void 0);
__decorate([Prop()], AuthItemsAttributeMappingDialog.prototype, "authItem", void 0);
AuthItemsAttributeMappingDialog = __decorate([Options({
  components: {
    MainTitle: MainTitle,
    Card: Card
  },
  watch: {
    isMapAttributeModalActive: function isMapAttributeModalActive() {
      this.visible = this.isMapAttributeModalActive;
    }
  }
})], AuthItemsAttributeMappingDialog);
export default AuthItemsAttributeMappingDialog;